<script>
import mixinComponent from '../../Mixins/mixinComponent'
import { globalVariablesMixin } from '../../Mixins/global'
import BlockContent from '../UI/Content/BlockContent.vue'
import CommentList from './CommentList.vue'

export default {
  components: { CommentList, BlockContent },
  mixins: [mixinComponent, globalVariablesMixin],

  props: {
    simulationId: { type: Number },
    contractId: { type: Number },
  },
}
</script>
<template>
  <div class="row">
    <div class="col-md-12">
      <BlockContent
        v-if="conf.comments && (user.isBusinessMan || user.isAdmin || conf.theme_dir === 'lbp')"
        title-level="4"
        e2e-block="comment"
      >
        <div class="row">
          <div v-if="simulationId" :class="contractId ? 'col-md-6' : 'col-md-12'">
            <h5>{{ $t('comment.simulation') }}</h5>
            <CommentList context="AppBundle\Entity\Simulation" :context-id="String(simulationId)" />
          </div>
          <div v-if="contractId" :class="simulationId ? 'col-md-6' : 'col-md-12'">
            <h5>{{ $t('comment.contract') }}</h5>
            <CommentList context="AppBundle\Entity\Contract" :context-id="String(contractId)" />
          </div>
        </div>
      </BlockContent>
    </div>
  </div>
</template>
